import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { UiButton, UiEmptyState } from '../../shared/ui';

@Component({
  selector: 'app-forbidden-page',
  imports: [RouterLink, UiButton, UiEmptyState],
  templateUrl: './forbidden.page.html',
  styleUrl: './forbidden.page.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ForbiddenPage {}
